import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-circle-left-red.svg'
import _imports_1 from '@/app/ui/assets/svg/arrow-circle-right-red.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-up-light.svg'
import _imports_3 from '@/app/ui/assets/svg/chevron-down-light.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-row items-center space-x-4 left-0 ml-8"
}
const _hoisted_2 = { class: "text-12px xxl:text-14px" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row space-x-4 left-0 ml-8"
}
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-12px xxl:text-14px text-gray-lp-300 font-semibold" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "text-20px flex items-center cursor-pointer ml-2 text-red-lp-100 font-semibold" }
const _hoisted_8 = { style: {"margin-left":"-14px","margin-right":"-14px","width":"300px"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "border-b border-gray-lp-400 px-4 py-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "inline-flex justify-between" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-16px" }, "Detail berat barang")
  ])
], -1)
const _hoisted_10 = { class: "flex flex-col pb-2 gap-1 p-4 text-14px xxl:text-14px text-black-lp-100" }
const _hoisted_11 = { class: "flex flex-row gap-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total barang ", -1)
const _hoisted_13 = { class: "text-1px text-right" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total berat kotor ", -1)
const _hoisted_15 = { class: "text-1px text-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total berat dimensi ", -1)
const _hoisted_17 = { class: "text-1px text-right" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "px-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_19 = { class: "flex flex-row pb-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow text-black-lp-100 text-14px xxl:text-14px float-left pl-4 pt-2" }, " Berat dikenakan biaya ", -1)
const _hoisted_21 = { class: "text-black-lp-100 text-1px xxl:text-14px pr-4 float-right text-right pt-2" }
const _hoisted_22 = {
  key: 0,
  class: "items-center ml-4 w-36"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-300" }, "Total Tarif", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "text-20px text-red-lp-100 font-bold" }, " IDR - ", -1)
const _hoisted_25 = { class: "flex flex-row z-20" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "float-left pl-18 pt-6 pr-4 w-32" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "items-center w-36"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-300" }, "Total Tarif", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "text-20px text-red-lp-100 font-bold" }, " IDR - ", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "float-right pt-6 pl-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_select_receipt_language = _resolveComponent("select-receipt-language")!
  const _component_Book = _resolveComponent("Book")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", {
    class: 
      `flex flex-row items-center ${
        _ctx.isShowArrow || _ctx.isShowWeightCost ? 'justify-between' : 'justify-end'
      } w-full`
    
  }, [
    (_ctx.isShowArrow)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previous())),
            alt: ""
          }),
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.indexElement + 1) + "/" + _toDisplayString(_ctx.shipmentList.length), 1),
          _createVNode("img", {
            src: _imports_1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next())),
            alt: ""
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowWeightCost)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('bookingShipment.column.chargeableWeight')), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.chargeableWeight) + " Kg ", 1),
              _withDirectives(_createVNode("div", {
                class: "flex items-center ml-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event)))
              }, [
                _createVNode("img", {
                  alt: "up",
                  class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'}`,
                  src: _imports_2
                }, null, 2),
                _createVNode("img", {
                  alt: "down",
                  class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''}`,
                  src: _imports_3
                }, null, 2)
              ], 512), [
                [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
              ])
            ]),
            _createVNode(_component_OverlayPanel, {
              ref: "opTooltip",
              appendTo: "body",
              class: "w-auto",
              unstyled: true
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.totalItem), 1)
                    ]),
                    _createVNode("div", {
                      class: `flex flex-row gap-1 ${_ctx.isGrossWeight && !_ctx.isCampaign ? 'text-black-lp-100' : 'text-gray-lp-600'}`
                    }, [
                      _hoisted_14,
                      _createVNode("div", _hoisted_15, _toDisplayString(_ctx.totalGrossWeight) + " kg ", 1)
                    ], 2),
                    _createVNode("div", {
                      class: `flex flex-row gap-1 text-gray-lp-600 ${
                    _ctx.isVolumeWeight && !_ctx.isCampaign
                          ? 'text-black-lp-100'
                          : 'text-gray-lp-600'
                      }`
                    }, [
                      _hoisted_16,
                      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.totalDimensionWeight) + " kg ", 1)
                    ], 2)
                  ]),
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode("div", _hoisted_21, _toDisplayString(_ctx.chargeableWeight) + " kg ", 1)
                  ])
                ])
              ]),
              _: 1
            }, 512)
          ]),
          (_ctx.isShowWeightCost)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24
              ]))
            : _createCommentVNode("", true)
        ], 512)), [
          [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
        ])
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_25, [
      _hoisted_26,
      (!_ctx.isShowWeightCost)
        ? (_openBlock(), _createBlock("div", _hoisted_27, [
            _hoisted_28,
            _hoisted_29
          ]))
        : _createCommentVNode("", true),
      _hoisted_30,
      (_ctx.isInterpack)
        ? (_openBlock(), _createBlock(_component_select_receipt_language, {
            key: 1,
            customStyleList: "bottom: 4.5rem",
            class: "pr-4"
          }))
        : _createCommentVNode("", true),
      (_ctx.isBooking)
        ? (_openBlock(), _createBlock(_component_Book, {
            key: 2,
            bookingType: _ctx.bookingType,
            payload: _ctx.payload,
            isPrintAble: _ctx.isPrintAble,
            isDisabled: _ctx.isDisabled,
            algoId: _ctx.algoId,
            onBooking: _ctx.updateEstimationPrice
          }, null, 8, ["bookingType", "payload", "isPrintAble", "isDisabled", "algoId", "onBooking"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}